import "../../styles/commentListView.css";
import { Avatar } from "@maysoft/common-component-react";
import { useCommentContext } from "../../providers/CommentProvider";

interface IProps {
    userId: string;
    userName: string;
    avatarUrl: string;

    level?: number;
    width?: number;
    height?: number;
}

const AvatarUserComment = ({ avatarUrl, userName, level, width, height }: IProps) => {
    const { userLogin, onClickShowProfile } = useCommentContext();

    return (
        <div className="cr-avatar-box" onClick={() => {
            onClickShowProfile && onClickShowProfile(userLogin)
        }}>
            <Avatar
                text={userName}
                src={avatarUrl}
                alt={"avt_user_login"}
                className={"cr-avatar"}
                style={{
                    width: width ? width : ((level || 1) === 1) ? 50 : 40,
                    height: height ? height : ((level || 1) === 1) ? 50 : 40,
                }}
            />
        </div>
    );
};

export default AvatarUserComment;
